import { Component, EventEmitter, Injector, Input, Output } from "@angular/core";
import { AbstractControl, ControlValueAccessor, NgControl, ValidationErrors, Validator, Validators } from "@angular/forms";
import { ComponentUtility } from "@app/class/ComponentUtility";
import './textarea.component.scss';

@Component({
    selector: 'v-textarea',
    template: require('./textarea.component.html'),
    providers: [
        ComponentUtility.createValueAccessorProvider(TextareaComponent),
        ComponentUtility.createValidatorProvider(TextareaComponent)
    ]
})
export class TextareaComponent implements ControlValueAccessor, Validator {
    @Input() label: string;
    @Input() value: string;

    @Input() rows: number = 4;
    @Input() disabled: boolean;
    @Input() placeholder: string = '';
    @Input() maxLength: number;
    @Input() name: string;
    @Input() readonly: boolean;
    @Input() required: boolean;

    @Output() valueChange = new EventEmitter<string>();

    constructor(
        protected readonly injector: Injector
    ) { }

    valueChanged(): void {
        this.onChange?.(this.value);
        this.valueChange.emit(this.value);
    }

    // --- Control Value Accessor

    onChange: (value: any) => void;
    onTouched: () => void;
    control: NgControl;

    registerOnChange(callback: (value: any) => void): void {
        this.onChange = callback;
    }

    registerOnTouched(callback: () => void): void {
        this.onTouched = callback;
    }

    writeValue(value: string): void {
        this.value = value;
    }

    setDisabledState(state: boolean) {
        this.disabled = state;
    }

    markAsTouched(): void {
        if (!this.onTouched || !this.control || this.control.touched) {
            return;
        }

        this.onTouched();
    }

    // Validator

    validate(control: AbstractControl): ValidationErrors | null {
        this.control = this.injector.get(NgControl);

        this.required = control.hasValidator(Validators.required);

        return null;
    }

    // --
}
